import { Link } from "react-router-dom";
import aboutHero from "../images/about_hero.svg";

export const About = () => {
  return (
    <>
      <div className="pageHero">
        <div className="pageHeroText">
          <h1 className="pageHeroTitle">About DOMMICRO</h1>
          <p className="pageHeroSubtitle">
            Your trusted partner in Information Technology — simplifying complexity
            and driving digital transformation for businesses of every size.
          </p>
        </div>
        <div className="pageHeroImageWrap hide-on-mobile">
          <img src={aboutHero} alt="DOMMICRO office building" className="pageHeroImg" />
        </div>
      </div>

      <div className="pageContent">

        <div className="serviceSection serviceSectionTinted">
          <p style={{ fontSize: "1.2rem", fontWeight: 600, color: "#1d3d71", lineHeight: 1.7, maxWidth: "780px", margin: "0 auto", textAlign: "center" }}>
            "We simplify the complexities of technology, bridging the gap between
            business goals and IT strategies — enabling organizations to unlock
            unprecedented levels of efficiency, security, and growth."
          </p>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <h3 className="sectionTitle">Who We Are</h3>
          <p>
            DOMMICRO LLC is a leading IT consulting firm that brings together
            technological expertise, business acumen, and an innovative mindset
            to transform your digital journey.
          </p>
          <p>
            We have dedicated ourselves to helping individuals and businesses of
            all sizes navigate the ever-evolving tech landscape — whether that
            means hardening your cybersecurity posture, modernizing infrastructure,
            building custom applications, or harnessing the power of AI and data
            analytics to drive better decisions.
          </p>
          <Link to="/services" className="ctaLink">Explore Our Services</Link>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <h3 className="sectionTitle" style={{ textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>Our Core Values</h3>
          <p style={{ maxWidth: "600px", margin: "4px auto 28px", textAlign: "center" }}>
            The principles that guide every engagement and every decision we make.
          </p>
          <div className="aiCardsRow">
            <div className="aiFeatureCard">
              <h6>Expertise</h6>
              <p>
                Certified professionals with years of cross-industry experience
                delivering reliable, high-quality IT outcomes.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Innovation</h6>
              <p>
                We stay at the forefront of technology — incorporating AI, cloud,
                and automation to keep our clients ahead of the curve.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Integrity</h6>
              <p>
                Honest assessments, transparent communication, and solutions that
                genuinely serve your best interests — always.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Partnership</h6>
              <p>
                We treat every client engagement as a long-term relationship,
                not just a project. Your success is our mission.
              </p>
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="calloutBox">
            <h4>Let's Work Together</h4>
            <p style={{ color: "rgba(255,255,255,0.88)", marginBottom: "20px" }}>
              Ready to take the next step in your digital transformation? We would
              love to learn about your goals and explore how DOMMICRO can help
              you get there.
            </p>
            <Link to="/contact" className="calloutCta">Get in Touch</Link>
          </div>
        </div>

      </div>
    </>
  );
};
